<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="$vuetify.lang.t('$vuetify.DASHBOARD.BOOKING')"
      :breadcrumbs="bookingProfiles.length <= 1 ? [
        {
          text: !selectedBookingProfile
            ? $vuetify.lang.t('$vuetify.DASHBOARD.BOOKING')
            : selectedBookingProfile.PlaceName,
          disabled: true
        }
      ] : []"
    >
      <template v-if="bookingProfiles.length > 1 && selectedBookingProfileId" v-slot:below>
        <div style="position: relative; max-width: 320px; left: 12px; top: -20px">
          <v-select
            :value="selectedBookingProfileId"
            :items="bookingProfiles"
            item-text="Name"
            item-value="BookingProfileID"
            :label="$vuetify.lang.t('$vuetify.LOCATION')"
            hide-details
            outlined
            @change="onProfileChange"
          />
          <v-chip
            x-small
            color="#2196F3"
            dark
            class="profile-new-badge"
          >
            {{ $vuetify.lang.t('$vuetify.NEW') }}
          </v-chip>
        </div>
      </template>
    </BaseBreadcrumb>
    <bookings-heat-chart
      v-if="
        (selectedBookingProfileId && !loading.state) ||
          loading.type === 'getBookings' ||
          loading.type === 'deleteBooking' ||
          loading.type === 'putBooking' ||
          loading.type === 'postBooking' ||
          loading.type === 'getBookingParkingStatusByVehicleNumber' ||
          loading.type === 'getBookablePlaceBookingsHeatmap' ||
          loading.type === 'endBooking' ||
          loading.type === 'getPriceForBookingInPlace' ||
          loading.type === 'getBookingReportXLSXFile'
      "
    />
    <v-card
      v-if="
        (selectedBookingProfileId && !loading.state) ||
          loading.type === 'getBookings' ||
          loading.type === 'deleteBooking' ||
          loading.type === 'putBooking' ||
          loading.type === 'postBooking' ||
          loading.type === 'getBookingParkingStatusByVehicleNumber' ||
          loading.type === 'getBookablePlaceBookingsHeatmap' ||
          loading.type === 'endBooking' ||
          loading.type === 'getPriceForBookingInPlace' ||
          loading.type === 'getBookingReportXLSXFile'
      "
      class="mt-3"
    >
      <v-card-text>
        <div v-if="!sessionsCountForbidden" class="d-flex align-center">
          <h3>
            {{ $vuetify.lang.t('$vuetify.BOOKING.ACTIVE_PARKINGS_CURRENTLY') }}
          </h3>
          <div style="width: 200px;" class="ml-3">
            <v-progress-linear
              height="25"
              :value="Math.round((sessionsCount / totalSpots) * 100, 1)"
              reactive
            >
              <span class="subtitle secondary--text"
                >{{ sessionsCount }} / {{ totalSpots }}</span
              >
            </v-progress-linear>
          </div>
        </div>
        <v-row>
          <v-col class="col-12">
            <div class="text-subtitle-1 text--primary">
              {{ $vuetify.lang.t('$vuetify.BOOKING.SEARCH_TITLE') }}
            </div>
          </v-col>
        </v-row>
        <v-form @submit.prevent>
          <v-row>
            <v-col cols="12" md="2" class="pt-0">
              <v-text-field
                v-model="licensePlate"
                hide-details
                :label="$vuetify.lang.t('$vuetify.BOOKING.CAR_NUMBER')"
                :aria-label="$vuetify.lang.t('$vuetify.BOOKING.CAR_NUMBER')"
                outlined
              >
                <!-- <v-icon slot="append">mdi-magnify</v-icon> -->
              </v-text-field>
            </v-col>
            <v-col cols="12" md="2" class="pt-0">
              <v-menu
                v-model="createdAtPicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="
                      selectedCreatedAt !== ''
                        ? datePickerFormat(selectedCreatedAt)
                        : ''
                    "
                    :label="$vuetify.lang.t('$vuetify.BOOKING.CREATED_AT')"
                    :placeholder="
                      $vuetify.lang.t('$vuetify.BOOKING.CREATED_AT')
                    "
                    append-icon="mdi-calendar"
                    readonly
                    outlined
                    hide-details
                    v-bind="attrs"
                    clearable
                    @click:clear="selectedCreatedAt = null"
                    @click:append="createdAtPicker = !createdAtPicker"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedCreatedAt"
                  :first-day-of-week="1"
                  @input="createdAtPicker = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="2" class="pt-0">
              <v-menu
                v-model="startTimePicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="
                      selectedStartTime !== ''
                        ? datePickerFormat(selectedStartTime)
                        : ''
                    "
                    :label="$vuetify.lang.t('$vuetify.BOOKING.START_TIME')"
                    :placeholder="
                      $vuetify.lang.t('$vuetify.BOOKING.START_TIME')
                    "
                    append-icon="mdi-calendar"
                    readonly
                    outlined
                    hide-details
                    v-bind="attrs"
                    :disabled="extraFilter === 'PARKING_ACTIVE'"
                    clearable
                    @click:clear="selectedStartTime = null"
                    @click:append="startTimePicker = !startTimePicker"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedStartTime"
                  :first-day-of-week="1"
                  @input="startTimePicker = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="2" class="pt-0">
              <v-menu
                v-model="endTimePicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="
                      selectedEndTime !== ''
                        ? datePickerFormat(selectedEndTime)
                        : ''
                    "
                    :label="$vuetify.lang.t('$vuetify.BOOKING.END_TIME')"
                    :placeholder="$vuetify.lang.t('$vuetify.BOOKING.END_TIME')"
                    append-icon="mdi-calendar"
                    readonly
                    outlined
                    hide-details
                    clearable
                    v-bind="attrs"
                    :disabled="extraFilter === 'PARKING_ACTIVE'"
                    @click:clear="selectedEndTime = null"
                    @click:append="endTimePicker = !endTimePicker"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedEndTime"
                  :first-day-of-week="1"
                  @input="endTimePicker = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="2" class="pt-0">
              <v-text-field
                v-model="client"
                hide-details
                :label="$vuetify.lang.t('$vuetify.BOOKING.CLIENT')"
                :aria-label="$vuetify.lang.t('$vuetify.BOOKING.CLIENT')"
                outlined
              >
                <!-- <v-icon slot="append">mdi-magnify</v-icon> -->
              </v-text-field>
            </v-col>
            <v-col cols="12" md="2" class="pt-0">
              <v-text-field
                v-model="comments"
                hide-details
                :label="$vuetify.lang.t('$vuetify.BOOKING.COMMENTS')"
                :aria-label="$vuetify.lang.t('$vuetify.BOOKING.COMMENTS')"
                outlined
              >
                <!-- <v-icon slot="append">mdi-magnify</v-icon> -->
              </v-text-field>
            </v-col>

            <v-col cols="12" md="2" class="pt-0">
              <v-select
                v-model="extraFilter"
                :items="extraFilters"
                item-text="text"
                item-value="name"
                hide-details
                :label="$vuetify.lang.t('$vuetify.EXTRA_FILTER')"
                :menu-props="{
                  bottom: true,
                  offsetY: true
                }"
                outlined
                clearable
              />
            </v-col>

            <v-col cols="12" md="2" sm="6" class="pt-0 d-flex align-center">
              <v-btn color="success" type="submit" @click="onSearchClick()">
                {{ $vuetify.lang.t('$vuetify.SEARCH') }}
              </v-btn>
              <v-btn
                v-if="selectedBookingProfile.ShouldCalculateCost"
                :loading="
                  loading.state && loading.type === 'getBookingReportXLSXFile'
                "
                color="white"
                class="success--text ml-3"
                @click="onGetBookingExcelReportClick()"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                {{ $vuetify.lang.t('$vuetify.EXPORT_TO_EXCEL') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
        <v-row class="d-flex justify-end mb-3">
          <v-btn color="success" text small @click.stop="onEditBookingClick()">
            <v-icon class="mr-2">mdi-plus</v-icon>
            {{ $vuetify.lang.t('$vuetify.BOOKING.ADD_NEW') }}
          </v-btn>
        </v-row>
        <v-data-table
          :headers="[
            {
              text: '#',
              align: 'start',
              sortable: false,
              value: 'OrderIndex'
            },
            {
              text: $vuetify.lang.t('$vuetify.BOOKING.CAR_NUMBER'),
              align: 'start',
              sortable: false,
              value: 'LicensePlate'
            },
            {
              text: $vuetify.lang.t('$vuetify.BOOKING.CREATED_AT'),
              align: 'start',
              sortable: false,
              value: 'CreatedAt'
            },
            {
              text: $vuetify.lang.t('$vuetify.BOOKING.START_TIME'),
              align: 'start',
              sortable: false,
              value: 'StartTime'
            },
            {
              text: $vuetify.lang.t('$vuetify.BOOKING.END_TIME'),
              align: 'start',
              sortable: false,
              value: 'EndTime'
            },
            {
              text: $vuetify.lang.t('$vuetify.BOOKING.NAME'),
              align: 'start',
              sortable: false,
              value: 'Name'
            },
            {
              text: $vuetify.lang.t('$vuetify.BOOKING.PHONE_NUMBER'),
              align: 'start',
              sortable: false,
              value: 'Phone'
            },
            {
              text: $vuetify.lang.t('$vuetify.BOOKING.EMAIL'),
              align: 'start',
              sortable: false,
              value: 'Email'
            },
            {
              text: $vuetify.lang.t('$vuetify.BOOKING.COMMENTS'),
              align: 'start',
              sortable: false,
              value: 'Comments'
            },
            {
              text: $vuetify.lang.t('$vuetify.BOOKING.COST'),
              align: 'start',
              sortable: false,
              value: 'CostInCents'
            },
            {
              text: '',
              align: 'start',
              sortable: false,
              value: 'actions'
            }
          ]"
          :items="bookings"
          :loading="
            loading.state &&
              (loading.type === 'getBookings' ||
                loading.type === 'deleteBooking' ||
                loading.type === 'putBooking' ||
                loading.type === 'postBooking')
          "
          hide-default-footer
          :items-per-page="pageSize"
        >
          <template v-slot:item.CreatedAt="props">
            <td>{{ dateEE(props.item.CreatedAt) }}</td>
          </template>
          <template v-slot:item.StartTime="props">
            <td>{{ dateEE(props.item.StartTime) }}</td>
          </template>
          <template v-slot:item.EndTime="props">
            <td>{{ dateEE(props.item.EndTime) }}</td>
          </template>
          <template v-slot:item.CostInCents="props">
            <td v-if="props.item.CostInCents > 0">
              {{ props.item.CostInCents / 100 }} EUR
            </td>
            <td v-else>-</td>
          </template>
          <!-- eslint-disable-next-line vue/no-unused-vars -->
          <template v-slot:item.actions="props">
            <td class="d-flex align-center">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    class="secondary--text"
                    @click.stop="onEditBookingClick(props.item)"
                    v-on="on"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $vuetify.lang.t('$vuetify.BOOKING.EDIT_BOOKING') }}
                </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    class="error--text"
                    @click.stop="onDeleteBookingClick(props.item)"
                    v-on="on"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $vuetify.lang.t('$vuetify.BOOKING.DELETE_BOOKING') }}
                </span>
              </v-tooltip>
              <v-menu v-if="!hasBookingEnded(props.item)" offset-y dense>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    v-if="!hasBookingEnded(props.item)"
                    @click="onEndBookingClick(props.item)"
                  >
                    <v-list-item-title>
                      {{ $vuetify.lang.t('$vuetify.BOOKING.END_BOOKING') }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </template>
        </v-data-table>
        <v-toolbar color="transparent" class="elevation-0">
          <v-spacer></v-spacer>
          <v-btn
            fab
            color="white"
            x-small
            class="ma-2"
            :disabled="currentPageNumber === 0"
            @click="prevPage()"
          >
            <v-icon color="rgba(0, 0, 0, 0.54)">mdi-menu-left</v-icon>
          </v-btn>
          <v-btn fab color="primary" class="secondary--text" x-small readonly>
            {{ currentPageNumber + 1 }}
          </v-btn>
          <v-btn
            fab
            color="white"
            x-small
            class="ma-2"
            :disabled="!nextAvailablePage || nextAvailablePage <= 0"
            @click="nextPage()"
          >
            <v-icon color="rgba(0, 0, 0, 0.54)">mdi-menu-right</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-col cols="1" class="pa-0">
            <v-select
              v-model="pageSize"
              :items="[10, 30, 50, 100]"
              :label="$vuetify.lang.t('$vuetify.STATISTICS.SHOW')"
              hide-details
              @change="onPageSizeChange"
            ></v-select>
          </v-col>
        </v-toolbar>
      </v-card-text>
    </v-card>
    <v-list v-if="!selectedBookingProfileId && !loading.state" class="pa-0">
      <v-list-item
        v-for="(item, index) in bookingProfiles"
        :key="index"
        selected
        style="border-bottom: 1px solid lightgray;"
        @click="onListItemClick(item.BookingProfileID)"
      >
        <v-list-item-title>{{ item.Name }}</v-list-item-title>
      </v-list-item>
    </v-list>

    <v-toolbar
      v-if="loading.state && loading.type === 'getBookingProfiles'"
      class="elevation-0 transparent"
    >
      <v-spacer></v-spacer>
      <v-progress-circular
        indeterminate
        color="secondary"
      ></v-progress-circular>
      <v-spacer></v-spacer>
    </v-toolbar>
    <edit-booking-dialog
      v-if="editBookingDialog"
      :title="
        selectedBooking.ID > 0
          ? $vuetify.lang.t('$vuetify.BOOKING.EDIT_BOOKING')
          : $vuetify.lang.t('$vuetify.BOOKING.ADD_NEW')
      "
      :visible="editBookingDialog"
      @close="editBookingDialog = false"
    />
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import formatDate from '@/mixins/formatDate'
import BookingsHeatChart from '@/components/booking/BookingsHeatChart'
import EditBookingDialog from '@/components/booking/EditBookingDialog'

export default {
  name: 'Booking',
  components: {
    BookingsHeatChart,
    EditBookingDialog
  },
  mixins: [formatDate],
  data() {
    return {
      createdAtPicker: false,
      selectedCreatedAt: '',
      startTimePicker: false,
      selectedStartTime: '',
      endTimePicker: false,
      selectedEndTime: '',
      licensePlate: '',
      client: '',
      comments: '',
      editBookingDialog: false,
      heatmapData: [],
      extraFilter: '',
      sessionsCount: undefined,
      totalSpots: undefined,
      availableSpots: undefined,
      sessionsCountForbidden: false
    }
  },
  computed: {
    ...mapGetters('booking', [
      'bookingProfiles',
      'bookings',
      'selectedBookingProfileId',
      'selectedBookingProfile',
      'selectedBooking',
      'nextAvailablePage',
      'currentPageNumber',
      'pageSize'
    ]),
    ...mapGetters('app', ['loading']),
    extraFilters: {
      get() {
        return [
          {
            name: 'PARKING_ACTIVE',
            text: this.$vuetify.lang.t('$vuetify.BOOKING.PARKING_ACTIVE')
          },
          {
            name: 'PARKING_NOT_ACTIVE',
            text: this.$vuetify.lang.t('$vuetify.BOOKING.PARKING_NOT_ACTIVE')
          },
          {
            name: 'STARTING_BOOKINGS',
            text: this.$vuetify.lang.t('$vuetify.BOOKING.STARTING_BOOKINGS')
          }
        ]
      }
    },
    ...mapGetters('app', ['loading']),
    currentPageNumber: {
      get() {
        return this.$store.state.booking.currentPageNumber
      },
      set(val) {
        this.setCurrentPageNumber(val)
      }
    },
    pageSize: {
      get() {
        return this.$store.state.booking.pageSize
      },
      set(val) {
        this.setPageSize(val)
      }
    }
  },
  watch: {
    selectedBookingProfileId(newVal) {
      if (newVal > 0) {
        this.fetchActiveSessionsCount()
      }
    },
    selectedCreatedAt(newVal) {
      if (newVal) {
        this.selectedStartTime = ''
      }
    }
  },
  async mounted() {
    await this.getBookingProfiles({ this: this })

    if (this.bookingProfiles.length === 1) {
      this.setSelectedBookingProfileId(this.bookingProfiles[0].BookingProfileID)
    }

    if (this.selectedBookingProfileId && this.selectedBookingProfileId > 0) {
      this.getBookings({
        this: this,
        bookingProfileId: this.selectedBookingProfileId,
        createdAt: this.serverFormat(this.selectedCreatedAt),
        startTime: this.serverFormat(this.selectedStartTime),
        endTime: this.serverFormat(this.selectedEndTime),
        client: this.client,
        comments: this.comments,
        extraFilter: this.extraFilter
      })

      this.fetchActiveSessionsCount()
    }
  },
  created() {
    const currentDate = new Date()
    this.selectedStartTime = this.formatDate(
      new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate()
      )
    )
  },
  methods: {
    ...mapActions('booking', [
      'getBookingProfiles',
      'getBookings',
      'deleteBooking',
      'getBookablePlaceBookingsHeatmap',
      'endBooking',
      'getBookingReportXLSXFile'
    ]),
    ...mapActions('places', ['getActiveSessionsCount']),
    ...mapActions('booking', [
      'getBookingProfiles',
      'getBookings',
      'deleteBooking',
      'getBookablePlaceBookingsHeatmap',
      'endBooking'
    ]),
    ...mapMutations('booking', [
      'setSelectedBookingProfileId',
      'setCurrentPageNumber',
      'setPageSize'
    ]),
    fetchActiveSessionsCount() {
      if (
        !this.selectedBookingProfile ||
        !this.selectedBookingProfile.PlaceID
      ) {
        return
      }
      this.sessionsCountForbidden = false
      this.getActiveSessionsCount(this.selectedBookingProfile.PlaceID)
        .then(data => {
          this.sessionsCount = data.sessionsCount
          this.totalSpots = data.totalSpots
          this.availableSpots = data.availableSpots
        })
        .catch(error => {
          if (error.response && error.response.status === 403) {
            this.sessionsCountForbidden = true
          }
          this.sessionsCount = '-'
        })
    },
    onListItemClick(bookingProfileId) {
      this.setSelectedBookingProfileId(bookingProfileId)
      this.getBookings({
        bookingProfileId,
        createdAt: this.serverFormat(this.selectedCreatedAt),
        startTime: this.serverFormat(this.selectedStartTime),
        endTime: this.serverFormat(this.selectedEndTime),
        client: this.client,
        comments: this.comments,
        extraFilter: this.extraFilter
      })
    },
    onProfileChange(bookingProfileId) {
      this.setCurrentPageNumber(0)
      this.setSelectedBookingProfileId(bookingProfileId)
      this.getBookings({
        bookingProfileId,
        createdAt: this.serverFormat(this.selectedCreatedAt),
        startTime: this.serverFormat(this.selectedStartTime),
        endTime: this.serverFormat(this.selectedEndTime),
        client: this.client,
        comments: this.comments,
        extraFilter: this.extraFilter
      })
    },
    datePickerFormat(dateValue) {
      const date = new Date(dateValue)
      return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`
    },
    serverFormat(dateValue) {
      if (!dateValue) {
        return undefined
      }
      const date = new Date(dateValue)
      const year = date.getFullYear()
      const month = `0${date.getMonth() + 1}`.slice(-2)
      const day = `0${date.getDate()}`.slice(-2)
      return `${year}-${month}-${day}`
    },

    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    onSearchClick() {
      this.getBookings({
        licensePlate: this.licensePlate,
        bookingProfileId: this.selectedBookingProfileId,
        createdAt: this.serverFormat(this.selectedCreatedAt),
        startTime: this.serverFormat(this.selectedStartTime),
        endTime: this.serverFormat(this.selectedEndTime),
        client: this.client,
        comments: this.comments,
        extraFilter: this.extraFilter
      })
    },
    onEditBookingClick(item) {
      if (item) {
        const selectedBookingCopy = JSON.parse(JSON.stringify(item))
        this.$store.commit('booking/setSelectedBooking', selectedBookingCopy)
      }
      this.editBookingDialog = true
    },
    onDeleteBookingClick(item) {
      this.$confirm(this.$vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE'), {
        title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
        color: 'error',
        icon: 'mdi-alert',
        persistent: true,
        buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
        buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
      }).then(option => {
        if (option === true) {
          this.deleteBooking({ this: this, bookingId: item.ID })
          this.close()
        }
      })
    },
    onEndBookingClick(item) {
      this.$confirm(
        this.$vuetify.lang.t('$vuetify.BOOKING.END_BOOKING_DESCRIPTION'),
        {
          title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
          color: 'error',
          icon: 'mdi-alert',
          persistent: true,
          buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
          buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
        }
      ).then(async option => {
        if (option) {
          this.endBooking({ this: this, bookingId: item.ID })
        }
      })
    },
    hasBookingEnded(booking) {
      const now = new Date()
      return new Date(booking.EndTime) < now
    },
    prevPage() {
      if (this.bookings.length > 0) {
        this.currentPageNumber -= 1
        this.getBookings({
          bookingProfileId: this.selectedBookingProfileId,
          createdAt: this.serverFormat(this.selectedCreatedAt),
          startTime: this.serverFormat(this.selectedStartTime),
          endTime: this.serverFormat(this.selectedEndTime),
          client: this.client,
          comments: this.comments,
          extraFilter: this.extraFilter
        })
      }
    },
    nextPage() {
      if (this.bookings.length !== 0) {
        this.currentPageNumber += 1
        this.getBookings({
          bookingProfileId: this.selectedBookingProfileId,
          createdAt: this.serverFormat(this.selectedCreatedAt),
          startTime: this.serverFormat(this.selectedStartTime),
          endTime: this.serverFormat(this.selectedEndTime),
          client: this.client,
          comments: this.comments,
          extraFilter: this.extraFilter
        })
      }
    },
    onPageSizeChange() {
      this.setCurrentPageNumber(0)
      this.getBookings({
        licensePlate: this.licensePlate,
        bookingProfileId: this.selectedBookingProfileId,
        createdAt: this.serverFormat(this.selectedCreatedAt),
        startTime: this.serverFormat(this.selectedStartTime),
        endTime: this.serverFormat(this.selectedEndTime),
        client: this.client,
        comments: this.comments,
        extraFilter: this.extraFilter
      })
    },
    onGetBookingExcelReportClick() {
      if (!this.selectedBookingProfile.ShouldCalculateCost) {
        return
      }
      const startTime = this.serverFormat(this.selectedStartTime)
      const createdAt = this.serverFormat(this.selectedCreatedAt)
      const fileLabel = startTime || createdAt || 'export'
      this.getBookingReportXLSXFile({
        bookingProfileId: this.selectedBookingProfileId,
        createdAt,
        startTime,
        endTime: this.serverFormat(this.selectedEndTime),
        licensePlate: this.licensePlate,
        client: this.client,
        comments: this.comments,
        extraFilter: this.extraFilter
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `${this.selectedBookingProfile.Name}-${fileLabel}.xlsx`
        )
        document.body.appendChild(link)
        link.click()
        link.remove()
      })
    }
  }
}
</script>

<style scoped>
.list {
  background: transparent;
}

.profile-new-badge {
  position: absolute;
  top: -10px;
  right: -8px;
  height: 20px;
  padding: 4px 6px;
  border-radius: 10px;
  font-size: 12px;
  line-height: 12px;
  pointer-events: none;
}
</style>
